module.exports = __webpack_public_path__ + "img/illusion-cn.8b7ca25.svg";